module.exports = __webpack_public_path__ + "img/10032.1d8786b7.jpg";